"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Home_1 = __importDefault(require("@mui/icons-material/Home"));
var Person_1 = __importDefault(require("@mui/icons-material/Person"));
var BottomNavigation_1 = __importDefault(require("@mui/material/BottomNavigation"));
var BottomNavigationAction_1 = __importDefault(require("@mui/material/BottomNavigationAction"));
var Notifications_1 = __importDefault(require("@mui/icons-material/Notifications"));
var Chat_1 = __importDefault(require("@mui/icons-material/Chat"));
var material_1 = require("@mui/material");
var react_router_dom_1 = require("react-router-dom");
var ShoppingCart_1 = __importDefault(require("@mui/icons-material/ShoppingCart"));
var js_cookie_1 = __importDefault(require("js-cookie"));
function BottomNav(props) {
    function getCookie(name) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
        var gettoken = js_cookie_1.default.get(name);
        return gettoken;
    }
    var navigate = (0, react_router_dom_1.useNavigate)();
    var token = getCookie("token");
    function navigator(location) {
        if (token) {
            navigate(location);
        }
        else {
            navigate("/login");
        }
    }
    return (react_1.default.createElement(BottomNavigation_1.default, { value: props.iconNumber - 1, color: "primary", sx: {
            position: "fixed",
            bottom: 0,
            zIndex: 9999,
            width: "100%",
        } },
        react_1.default.createElement(BottomNavigationAction_1.default, { label: react_1.default.createElement(material_1.Typography, { variant: "body1" }, "Home"), icon: react_1.default.createElement(Home_1.default, null), component: react_router_dom_1.Link, to: "/" }),
        react_1.default.createElement(BottomNavigationAction_1.default, { label: react_1.default.createElement(material_1.Typography, { variant: "body1" }, "Chat"), icon: react_1.default.createElement(Chat_1.default, null), href: "/chat" }),
        react_1.default.createElement(BottomNavigationAction_1.default, { label: react_1.default.createElement(material_1.Typography, { variant: "body1" }, "Cart"), icon: react_1.default.createElement(ShoppingCart_1.default, null), component: react_router_dom_1.Link, to: "/cart" }),
        react_1.default.createElement(BottomNavigationAction_1.default, { label: react_1.default.createElement(material_1.Typography, { variant: "body1" }, "Notifications"), icon: react_1.default.createElement(Notifications_1.default, null), component: react_router_dom_1.Link, to: "/notifications" }),
        react_1.default.createElement(BottomNavigationAction_1.default, { label: react_1.default.createElement(material_1.Typography, { variant: "body1" }, "profile"), icon: react_1.default.createElement(Person_1.default, null), onClick: function () { return navigator("/profile"); } })));
}
exports.default = BottomNav;
